// Module
var code = `<page-title value="Selection Options"></page-title> <main class="flex flex-col flex-grow gap-4 p-page px-1"> <app-selection-options-renderer [selectionSets]="this.selectionSets" [(selectedSelectionSet)]="this.selectedSelectionSet" class="flex flex-grow"> </app-selection-options-renderer> </main> `;
// Exports
export default code;